"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stubClient = _interopRequireDefault(require("./stubClient"));

/**
 * The browser implementation is a stub that implements the DatadogClient
 * interface but does not actually report any metrics.
 */
var _default = _stubClient.default;
exports.default = _default;